export const EVENTS_CHANNEL = 'instock:events';

// Common
export const EVENT_WIDGET_INITIALIZED = 'initialized';
export const EVENT_FILTERS_READY = 'filters_ready';
export const EVENT_CONSTRUCTOR_READY_TO_RENDER = 'constructor_ready_to_render';

// Cars
export const EVENT_CAR_DATA_RECEIVED = 'car_data_received';

// Filters
export const EVENT_FILTER_VALUE_CHANGED = 'filter_value_changed';

// Go to page
export const EVENT_CAR_PAGE_VISITED = 'car_page_visited';
export const EVENT_CARS_PAGE_VISITED = 'cars_page_visited';
export const EVENT_COMPARISON_PAGE_VISITED = 'comparison_page_visited';
export const EVENT_FAVORITES_PAGE_VISITED = 'favorites_page_visited';
export const EVENT_MODELS_PAGE_VISITED = 'models_page_visited';

// Button
export const EVENT_BUTTON_CLICKED = 'button_clicked';
